import React from 'react';
import Color from './Color';
import { View, Text } from 'react-native';
export default (function () {
  return React.createElement(View, {
    style: {
      padding: 20
    }
  }, React.createElement(Text, {
    style: {
      color: Color.alizarin,
      fontWeight: '600'
    }
  }, "Video is not yet implemented for the web"));
});